module.exports = __webpack_public_path__ + "media/site_templates/www.concreters.company/images/our_services_1-e27e89af684b6539001559743a446d66.jpg";